import {extend, override} from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import UserPage from 'flarum/forum/components/UserPage';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import LinkButton from 'flarum/common/components/LinkButton';
import icon from 'flarum/common/helpers/icon';
import EventsPage from './EventsPage';

let showLogoPreview = false;

app.initializers.add('robots-ju-inscriptions', () => {
    app.routes.robotsjuEvents = {
        path: '/events',
        component: EventsPage,
    };

    extend(IndexPage.prototype, 'sidebarItems', function (items) {
        if (items.has('newDiscussion')) {
            items.remove('newDiscussion');
        }
    });

    extend(IndexPage.prototype, 'navItems', function (items) {
        if (items.has('allDiscussions')) {
            items.remove('allDiscussions');
        }

        items.add('robots-ju', LinkButton.component({
            icon: 'fas fa-poll-h',
            href: app.route('robotsjuEvents'),
        }, 'Événements'));
    });

    extend(HeaderSecondary.prototype, 'items', function (items) {
        if (items.has('search')) {
            items.remove('search');
        }

        if (items.has('notifications')) {
            items.remove('notifications');
        }
    });

    extend(SessionDropdown.prototype, 'items', function (items) {
        if (items.has('profile')) {
            items.remove('profile');
        }
    });

    extend(UserPage.prototype, 'navItems', function (items) {
        if (items.has('posts')) {
            items.remove('posts');
        }

        if (items.has('discussions')) {
            items.remove('discussions');
        }
    });

    extend(SettingsPage.prototype, 'settingsItems', function (items) {
        if (items.has('notifications')) {
            items.remove('notifications');
        }

        if (items.has('privacy')) {
            items.remove('privacy');
        }
    });

    extend(flarum.extensions['kilowhat-formulaire'].fields.Field.prototype, 'setSubmission', function () {
        // Open preview when uploading new logo
        if (this.getConfig('key') === 'logo') {
            showLogoPreview = true;
        }
    });

    extend(flarum.extensions['kilowhat-formulaire'].fields.Upload.prototype, 'fill', function (vdom) {
        if (this.getConfig('key') !== 'logo') {
            return;
        }

        const submissions = this.getSubmission([]);

        let file = null;

        if (submissions.length) {
            file = app.store.getById('formulaire-files', submissions[0]);
        }

        vdom.push(m('.RobotsJUCoupeLogoPreview', [
            m('h5', {
                onclick() {
                    showLogoPreview = !showLogoPreview;
                },
            }, [
                'Aperçu logo ',
                icon('fas fa-chevron-' + (showLogoPreview ? 'up' : 'down')),
            ]),
            showLogoPreview ? [
                m('.column', [
                    m('h6', 'Dans le classement'),
                    m('.live-ranking', m('.teams', [
                        m('.team', [
                            m('.rank'),
                            m('.logo.placeholder'),
                            m('.name', 'Autre équipe'),
                        ]),
                        m('.team', [
                            m('.rank'),
                            m('.logo', file ? {
                                style: {
                                    backgroundImage: 'url("' + encodeURI(file.url()) + '")',
                                },
                            } : {}),
                            m('.name', (this.submission.name && this.submission.name.value) || 'Nom d\'équipe'),
                        ]),
                        m('.team', [
                            m('.rank'),
                            m('.logo.placeholder'),
                            m('.name', 'Autre équipe'),
                        ]),
                    ])),
                ]),
                m('.column', [
                    m('h6', 'Sur la table de match'),
                    m('.match-table', [
                        m('.logo', file ? {
                            style: {
                                backgroundImage: 'url("' + encodeURI(file.url()) + '")',
                            },
                        } : {}),
                        m('.name', (this.submission.name && this.submission.name.value) || 'Nom d\'équipe'),
                    ]),
                ]),
            ] : null,
        ]));
    });

    override(flarum.extensions['kilowhat-formulaire'].fields.Field.prototype, 'choiceView', function (original, renderLabelAndInput: any, ...args) {
        return original((checked: boolean, onchange: () => void, disabled: boolean, key: string, children: any) => {
            if (this.getConfig('key') === 'preferred-robot' && ['ev3', 'spike'].indexOf(key) !== -1) {
                children = m('.RobotsJUCoupePreferredRobotLabel', [
                    children,
                    m('img', {
                        src: app.forum.attribute('baseUrl') + '/assets/platform-' + key + '.jpg',
                    }),
                ]);
            }

            return renderLabelAndInput(checked, onchange, disabled, key, children);
        }, ...args);
    });
});
